export const Getalluserdetail = `query GetAllCustomUserDetails($search: String!, $page: Int!, $pageSize: Int!) {
getAllCustomUserDetails(search: $search, page: $page, pageSize: $pageSize) {
success
error
message
totalCount
currentPage
totalPages
hasNextPage
hasPreviousPage
data {
id
username
firstName
lastName
gender
language
mailAddress
address
countryCode
contactNumber
primaryCountryCode
primaryContactNumber
dateOfBirth
dateOfJoining
dateOfRelieving
status
role {
id
roleName
}
teamLeader {
id
username
}
clientHandling {
id
clientName
}
}
}
}
`;

export const getClientsByUserId = `
query GetClientsByUserDetailId($userDetailId: Int!) {
  getClientsByUserDetailId(userDetailId: $userDetailId) {
    success
    error
    message
    data {
      id
      clientName
      hiringType
      primaryContactPerson
      address
      mapLocation
      mailAddress
      countryCode
      contactNumber
      srDays
      createdAt
      createdBy
      lastUpdate
      updatedBy
 
      industry {
        id
        industryType
        hiringType
        createdAt
      }
    }
  }
}`;

export const getByTLUserdetail = `
query GetTeamLeaderById($id: Int!) {
  getTeamLeaderUserById(id: $id) {
    success
    error
    message
    data {
      id
      username
      firstName
      lastName
      gender
      language
      mailAddress
      address
      countryCode
      contactNumber
      primaryCountryCode
      primaryContactNumber
      dateOfBirth
      dateOfJoining
      dateOfRelieving
      status
      role {
        id
        roleName
      }
      teamLeader {
        id
        username
      }
      clientHandling {
        id
        clientName
      }
    }
  }
}
`;

export const Createuserdetail = `
mutation CreateCustomUser($input: CreateCustomUserInput!) {
  createCustomUser(input: $input) {
    success
    error
    message
    data {
      id
      username
      email
    }
  }
}
`;

export const Deleteuser = `mutation DeleteCustomUser($input: DeleteCustomUserInput!) {
  deleteCustomUser(input: $input) {
    success
    error
    message
  }
}`;

export const Updateuser = `mutation UpdateCustomUser($input: UpdateCustomUserInput!) {
  updateCustomUser(input: $input) {
    success
    error
    message
    data {
      id
      username
      email
    }
  }
}
`;



export const GetalluserdetailDropdown = `query GetAllCustomUserDetails($search: String!, $page: Int!, $pageSize: Int!) {
getAllCustomUserDetails(search: $search, page: $page, pageSize: $pageSize) {
success
error
message
totalCount
currentPage
totalPages
hasNextPage
hasPreviousPage
data {
id
username
firstName
lastName
gender
language
mailAddress
address
countryCode
contactNumber
primaryCountryCode
primaryContactNumber
dateOfBirth
dateOfJoining
dateOfRelieving
status
role {
id
roleName
}
teamLeader {
id
username
}
clientHandling {
id
clientName
}
}
}
}
`;


export const GETCLIENTDROPDOWN = `
  query GetAllClients($search: String, $page: Int!, $pageSize: Int!) {
    getAllClients(search: $search, page: $page, pageSize: $pageSize) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        clientName
        industry {
          id
          industryType
        }
        hiringType
        primaryContactPerson
        address
        mapLocation
        mailAddress
        countryCode
        contactNumber
        srDays
        createdAt
        createdBy
        lastUpdate
        updatedBy
      }
    }
  }
`;